import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeSelector } from "./themes/ThemeSelector";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <ThemeSelector>
            <App />
        </ThemeSelector>
    </React.StrictMode>
);
